// extracted by mini-css-extract-plugin
export default {"mentionMenu":"Ticrtch8NP","mentionMenu_dropover":"nDFmo7ItAc"};